import io from "socket.io-client";
// socket.connect();
const socket = io("https://horserace.eiki.is", {
  autoConnect: false,
});

export default function socketReducer(state = socket, action) {
  return state;
}
